<template>
  <div class="row">
    <div
      v-for="(alternative, aindex) of question.alternatives.list"
      :key="alternative.id"
      class="col col-12 col-md-6 mb-4">
      <li class="c-alternative-container ul-reset">
        <input
          v-model="fillQuestion"
          :id="`alternative-${qindex}-${aindex}`"
          :type="question.type"
          :value="alternative.id"
          class="d-none">
        <label :for="`alternative-${qindex}-${aindex}`" class="c-alternative p-2">
          <div class="d-flex">
            <div class="me-3">
              <div class="c-alternative__vineta">
                {{ vineta(aindex) }}
              </div>
            </div>
            <div class="flex-grow-1">
              <figure class="w-100 br--small overflow-hidden">
                <img class="c-alternative__image of--contain" :src="alternative.image" alt="" />
              </figure>
            </div>
          </div>
        </label>
      </li>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: ['question', 'qindex'],
  computed: {
    fillQuestion: {
      get: function() {
        return this.question.answer;
      },
      set: function(answer) {
        this.$emit('update:question', {
          ...this.question,
          answer: answer,
        })
      },
    },
  },
  methods: {
    vineta: function(index) {
      switch (index) {
        case 0:
          return 'a.';
          break;
        case 1:
          return 'b.';
          break;
        case 2:
          return 'c.';
          break;
        case 3:
          return 'd.';
          break;
        case 4:
          return 'e.';
          break;
        case 5:
          return 'f.';
          break;
      }
    },
  },
}
</script>
